module.exports = __webpack_public_path__ + "static/media/cover_black_fade_overlay.0a568b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cards/cover/cover_black_fade_overlay.png
// module id = 1563
// module chunks = 0